"use client";
import style from "./style.module.scss";
import JDIProductCardV2 from "@/common-components-src/js/productCard_V2/index";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Prev from "@/assets/icons/prev.svg";
import Next from "@/assets/icons/next.svg";
import React from "react";
interface SwiperProps {
  products: any;
  swiperRef: any;
  isDataReady: any;
  setIsDataReady: any;
}
function FlashSalesSwiper(props: SwiperProps) {
  const { products, swiperRef, isDataReady, setIsDataReady } = props;
  return (
    <Swiper
      slidesPerView={5}
      loop={true}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper;
      }}
      className={style.mySwiper}
      style={{
        visibility: isDataReady ? "visible" : "hidden",
      }}
      onSwiper={() => {
        setIsDataReady(true);
      }}
    >
      {products?.map((product: any, index: number) => (
        <SwiperSlide key={index}>
          <JDIProductCardV2 productData={product} key={product.skuId} />
        </SwiperSlide>
      ))}
      <div className={style.buttonGroup}>
        <button className={style.prev} onClick={() => swiperRef.current?.slidePrev()}>
          <Prev />
        </button>
        <button className={style.next} onClick={() => swiperRef.current?.slideNext()}>
          <Next />
        </button>
      </div>
    </Swiper>
  );
}
export default React.memo(FlashSalesSwiper);
